import Layout from "../layout"
import Page from "../components/page"
import VideoPlayer from "../components/video-player"
import Menu from "../components/menu"
import Motion from "../components/motion"

class App extends Layout {
    constructor() {
        super()
        this.page = new Page()
        this.menu = new Menu()
        this.videoPlayer = new VideoPlayer()
        
        // Motion se inicializa después de que el DOM esté listo
        // Como Motion ya maneja internamente la espera de GSAP, no necesitamos lógica adicional
        this.motion = new Motion()
    }
}

const _app = new App()